/* eslint-disable @typescript-eslint/no-explicit-any */

import { config } from "@/config";
import {
  IIBaseResponse,
  v1SessionIdPost,
} from "@/contract/generated/electrify-v1";
import { useApi } from "@/hooks/useApi";
import { isError } from "@/utils";
import { setSessionId } from "@/utils/sessionId";

export const useSession = () => {
  const { call } = useApi();

  const createSessionId = async () => {
    const result = await call(() => v1SessionIdPost(config.apiBasePath));

    if (isError(result)) {
      return {
        error: result as Error,
      };
    }

    const response = result as IIBaseResponse;

    setSessionId(response.sessionId);

    return {
      sessionId: response.sessionId,
    };
  };

  return {
    createSessionId,
  };
};
